import { axiosInstance } from "../utils/axios";
import { getAuthHeader, getToken } from "../utils/authTools";

export const summarizeOpenAITranscript = async (request) => {
    let response = await axiosInstance.patch(
        `/summarize/openai/${request.id}`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const summarizeTranscript = async (request, signal) => {
    let response = await axiosInstance.patch(
        `/summarize/bastion/${request.id}`,
        request,
        {
            headers: { Authorization: `Bearer ${getToken()}` },
            signal: signal,
        }
    );
    return response.data;
};


export const clearSummary = async (request) => {
    let response = await axiosInstance.patch(
        `/summarize/clear/${request.id}`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const summarizeOpenAIUpload = async (request) => {
    let response = await axiosInstance.patch(
        `/summarize/upload/openai/${request.id}`,
        request,
        getAuthHeader()
    );
    return response.data;
};

export const summarizeBastionUpload = async (request) => {
    let response = await axiosInstance.patch(
        `/summarize/upload/bastion/${request.id}`,
        request,
        getAuthHeader()
    );
    return response.data;
};